// extracted by mini-css-extract-plugin
module.exports = {"icon":"popup-icon_icon__33x_E","popup":"popup-icon_popup__215wU"};